import request from '@/api/request'
import type { PayOrderRow, SpringPage } from '@/api/types/domain'

/** Spring Pageable：`page` 从 0 开始；对齐 Admin/Payorder：keyword→订单号模糊，phone→手机号模糊 */
export function fetchPayOrders(
  page = 0,
  size = 15,
  opts?: { keyword?: string; phone?: string; search?: string },
) {
  const kw = opts?.keyword?.trim()
  const ph = opts?.phone?.trim()
  const search = opts?.search?.trim()
  return request.get<SpringPage<PayOrderRow>>('/api/admin/backoffice/payorders', {
    params: {
      page,
      size,
      sort: 'addtime,desc',
      ...(search ? { search } : {}),
      ...(!search && kw ? { keyword: kw } : {}),
      ...(!search && ph ? { phone: ph } : {}),
    },
  })
}

/** 对标 changecard：更新收款账户 / 卡号（≥11 位） */
export function patchPayOrderAccount(id: number, account: string) {
  return request.patch<{ status: number; msg: string }>(`/api/admin/backoffice/payorders/${id}/account`, {
    account,
  })
}

/** 对标 changestatus：-1 / 3 / 4 等 */
export function patchPayOrderWithdrawStatus(id: number, status: number) {
  return request.patch<{ status: number; msg: string }>(`/api/admin/backoffice/payorders/${id}/status`, {
    status,
  })
}

export function deletePayOrder(id: number) {
  return request.delete<{ status: number; msg: string }>(`/api/admin/backoffice/payorders/${id}`)
}
